import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import s from './LazyPlaceholder.scss';
var LazyPlaceholder = function () {
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(s['root']) }, t('commentbox.editor.placeholder')));
};
LazyPlaceholder.displayName = 'LazyPlaceholder';
export default LazyPlaceholder;
//# sourceMappingURL=LazyPlaceholder.js.map